
import { KYMW6800Model } from '../kymw6800.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * カテゴリマスタ取得する
 *
 * @export API通信成功時の処理
 * @class GetCategoryInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCategoryInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6800Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCategoryInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        // リクエストパラメータをカテゴリ区分から在庫限定へ変更
        // CategoryDiv: this.vo.categoryDiv,
        StockLimitFlg: this.vo.stockLimitFlg,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6800Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCategoryInfoService
   */
  execute(model: KYMW6800Model, vo: any, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('get68CategoryInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCategoryInfoService
   */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
    if (data !== null) {
      this.model.setTreeView(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetCategoryInfoService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }

}
